import { useState, useEffect } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { getTemplateIdAttributesForAnalytics } from '@confluence/template-utils/entry-points/templateUtils.ts';

export const useDiscardChanges = ({ discardDraftDefault = false, onClose, onCreate, template }) => {
	const [discardDraft, setDiscardDraft] = useState<boolean>(discardDraftDefault);
	const { createAnalyticsEvent } = useAnalyticsEvents();

	useEffect(() => {
		// screen event should be triggered once
		createAnalyticsEvent({
			type: 'sendScreenEvent',
			data: {
				source: 'templateCreateNewPageDialogModal',
				name: 'templateCreateNewPageDialogModalScreen',
				attributes: {
					...getTemplateIdAttributesForAnalytics(template),
				},
			},
		}).fire();
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	const onCloseHandler = () => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				action: 'clicked',
				actionSubject: 'button',
				actionSubjectId: 'discardDraftCancel',
				source: 'templateCreateNewPageDialogModal',
			},
		}).fire();

		onClose();
	};

	const discardDraftToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
		const toggledState = event.target.checked;

		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				action: 'toggled',
				actionSubject: 'option',
				actionSubjectId: 'discardDraftOption',
				source: 'templateCreateNewPageDialogModal',
				attributes: {
					toggled: toggledState,
				},
			},
		}).fire();

		setDiscardDraft(toggledState);
	};

	const onCreateHandler = () => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				action: 'clicked',
				actionSubject: 'button',
				actionSubjectId: 'discardDraftCreate',
				source: 'templateCreateNewPageDialogModal',
				attributes: {
					toggled: discardDraft,
					...getTemplateIdAttributesForAnalytics(template),
				},
			},
		}).fire();

		onCreate(template, discardDraft);
		// need to close the dialog because it overrides the blueprint wizard's input focus
		onClose();
	};

	return {
		discardDraftToggle,
		onCloseHandler,
		onCreateHandler,
	};
};
